var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{staticClass:"justify-center"},[_c('v-col',{staticClass:"text-center"},[_c('h1',{staticClass:"mt-5"},[_vm._v("Valitettavasti sivua ei löytynyt")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }